import {ApplicationInsights, ITelemetryItem} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from "@microsoft/applicationinsights-clickanalytics-js";
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
  autoCapture: true,
  useDefaultContentNameOrId: true,
};
const appInsights = new ApplicationInsights({ config: {
    connectionString: process.env.REACT_APP_INSIGHTS_CONN,
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
      // *** Add the Click Analytics plug-in. ***
      // [clickPluginInstance.identifier]: clickPluginConfig
    }
  },
});
appInsights.loadAppInsights();
appInsights.trackPageView();
// appInsights.addTelemetryInitializer((ITelemetryItem) => {
//   env.tags = env.tags || {};
//   env.tags["ai.cloud.role"] = "<app-role-frontend>";
//   //custom props
//   env.data = env.data || {};
//   env.data["ms-appName"] = "<frontend-name>";
//   env.data["ms-user"] = "<frontend-auth-user>";
//   env.data["ms-userid"] = "<frontend-auth-userid>";
// });

export { reactPlugin, appInsights };